import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../../shared/services/api.service';
import { Urls } from '../../utils/urls';
import { CommonDataService } from '../../shared/services/common-data.service';
import { GrowthMenuComponent } from './growth-menu/growth-menu.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import value from '*.json';
import { environment } from '../../../environments/environment.prod'
import { RedirectionService } from '@root/shared/services/redirection.service';
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  fundParams:any = {
    investmentHorizon: [],
    investmentHorizonSelectionMap: {},
    investmentPurpose: [],
    investmentPurposeSelectionMap: {},
    risk: [],
    riskSelectionMap: {},
    plan: 'Direct Plan - Growth Option'
  };
  activeTab = 'all';
  @ViewChildren('[role="tab"]', { read: ElementRef })
tabElements!: QueryList<ElementRef>;
  tabs = ['all', 'equity', 'debt', 'hybrid', 'other'];
  liveMessage = '';
  debtCount = 0;
  equityCount = 0;
  hyBridCount = 0;
  otherCount = 0;
  // fundsData = [];
  fundsData: any[] = [];
  viewFilters = false;
  schemeType = [
    {
      displayName: 'Direct Scheme',
      value: 'Direct Plan - Growth Option'
    },
    {
      displayName: 'Regular Scheme',
      value: 'Regular Plan - Growth Option'
    },
  ];
  filtersData = [
    {
      heading: 'Investment Risks',
      name: 'risk',
      datas: [
        {
          displayName: 'Very High risks',
          value: 'Very High'
        },
        {
          displayName: 'High risks',
          value: 'High'
        },
        {
          displayName: 'Moderately High risks',
          value: 'Moderately High'
        },
        {
          displayName: 'Moderate risks',
          value: 'Moderate'
        },
        {
          displayName: 'Low to Moderate risks',
          //value: 'Moderately Low'
          value: 'Low to Moderate'
        },
        {
          displayName: 'Low risks',
          value: 'Low'
        }

      ]
    },
    {
      heading: 'Investment Horizon',
      name: 'investmentHorizon',
      datas: [
        {
          displayName: 'Short Term',
          value: 'Short Term'
        },
        {
          displayName: 'Medium Term',
          value: 'Medium Term'
        },
        {
          displayName: 'Long Term',
          value: 'Long Term'
        }

      ]
    },
    {
      heading: 'Investment Purpose',
      name: 'investmentPurpose',
      datas: [
        {
          displayName: 'Tax Saving',
          value: 'Tax Saving'
        },
        {
          displayName: 'Wealth Creation',
          value: 'Long Term Wealth Creation'
        },
        {
          displayName: 'Lowest in Equity segment',
          value: 'Lowest risk product in Equity segment'
        },
        {
          displayName: 'Short Term Parking',
          value: 'Short Term Parking'
        },
        {
          displayName: 'Lowest risk fund',
          value: 'Lowest risk fund'
        }

      ]
    }
  ];

  tabsList = [
    {
      displayName: 'All Funds',
      value: 'all'
    },
    {
      displayName: 'Equity Funds',
      value: 'equity'
    },
    {
      displayName: 'Debt Funds',
      value: 'debt'
    },
    {
      displayName: 'Hybrid Funds',
      value: 'hybrid'
    },
    {
      displayName: 'Others',
      value: 'other'
    }
  ];
  constructor(public route: ActivatedRoute,
    public router: Router,
    private modalService: NgbModal,
    private apiService: ApiService,
    public commonDataService: CommonDataService, private redirectionService : RedirectionService) {

  }

  ngOnInit() {
    this.scrollTop();
    this.getFunds();
  }
  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

 getFunds = () => {
  this.apiService.postData(Urls.getTop3Funds, this.fundParams).subscribe(
    (response) => {
      this.fundsData = response.data.returnValue;
      this.getFundCounts(response.data.returnValue);

      this.liveMessage =
        `${this.fundsData.length} funds available.`;
    },
    (error) => {
      this.fundsData = [];
      this.debtCount = this.equityCount = this.hyBridCount = this.otherCount = 0;

      this.liveMessage = 'No funds available.';
    }
  );

  this.viewFilters = false;
}

  getFundCounts = (data: any) => {
    this.debtCount = 0;
    this.equityCount = 0;
    this.hyBridCount = 0;
    this.otherCount = 0;
    for (const item of data) {
      if (item.fundType === 'Debt') {
        this.debtCount++;
      } else if (item.fundType === 'Equity') {
        this.equityCount++;
      } else if (item.fundType === 'Hybrid') {
        this.hyBridCount++;
      } else {
        this.otherCount++;
      }
    }
  }

  setPlan = (val: string) => {
  this.fundParams.plan = val;

  this.liveMessage =
    `${val === 'Direct Plan - Growth Option' ? 'Direct Scheme' : 'Regular Scheme'} selected. Updating funds.`;

  this.getFunds();
}
  splitString = (val: string) => {
    if (val) {
      const str1 = val.split('-')[0].split(' ')[0];
      const str2 = val.split('-')[1].split(' ')[1];
      return str1 + ' - ' + str2;
    } else {
      return ''
    }
  }

  setActive = (val: string) => {
    this.activeTab = val;
  }

moveToNextTab() {
  const index = this.tabs.indexOf(this.activeTab);
  const next = (index + 1) % this.tabs.length;

  this.setActive(this.tabs[next]);

  requestAnimationFrame(() => {
    document.getElementById('tab-' + this.tabs[next])?.focus();
  });
}

moveToPreviousTab() {
  const index = this.tabs.indexOf(this.activeTab);
  const previous = (index - 1 + this.tabs.length) % this.tabs.length;

  this.setActive(this.tabs[previous]);

  requestAnimationFrame(() => {
    document.getElementById('tab-' + this.tabs[previous])?.focus();
  });
}

  viewDetails = (schemename: string, schemedetails: any) => {
    let url = schemename.replace(/\s/g, "-");
    this.router.navigateByUrl('products/' + url.toLowerCase());
  }

  investOnline = () => {
    this.redirectionService.redirectToInvestorPortal();
    // if (!environment.isDRBuild) {
    //   window.open("https://investonline.itiamc.com/", "_blank");
    // } else {
    //   window.open("https://investonline.itiamc.com/", "_blank"); //DR-inv
    // }
  }
applyFilters = (evt: any, name: any, val: any) => {
  if (evt.target.checked) {
    this.fundParams[name].push(val);
    this.liveMessage = `${val} filter selected. Updating funds.`;
  } else {
    const index = this.fundParams[name].indexOf(val);
    this.fundParams[name].splice(index, 1);
    this.liveMessage = `${val} filter removed. Updating funds.`;
  }

  this.getFunds();
}
  setMobileFilterOptionsFilters = (evt: any, name: any, val: any) => {
  const selectionKey = `${name}SelectionMap`;

  if (evt.target.checked) {
    this.fundParams[name].push(val);

    if (this.fundParams[selectionKey]) {
      this.fundParams[selectionKey][val] = val;
    }

    this.liveMessage = `${val} filter selected. Updating funds.`;
  } else {
    const index = this.fundParams[name].indexOf(val);
    this.fundParams[name].splice(index, 1);

    if (this.fundParams[selectionKey]) {
      delete this.fundParams[selectionKey][val];
    }

    this.liveMessage = `${val} filter removed. Updating funds.`;
  }
}

  clearMobileFilters = () => {
    this.fundParams.investmentHorizon = [];
    this.fundParams.investmentPurpose = [];
    this.fundParams.investmentHorizonSelectionMap = {};
    this.fundParams.investmentPurposeSelectionMap = {};
    this.fundParams.risk = [];
    this.fundParams.riskSelectionMap = {};
    this.viewFilters = false;
    this.getFunds();
  }

  setFilterSection = (val: boolean) => {
    this.viewFilters = val;

  }

  openPopUpScheme = () => {
    const modalRef = this.modalService.open(GrowthMenuComponent, { size: 'sm', windowClass: 'align-modal-scheme', backdrop: false, });
    modalRef.componentInstance.valueScheme = this.fundParams.plan;
    modalRef.componentInstance.passEntry.subscribe((data: any) => {
      this.fundParams.plan = data;
      this.getFunds();
    });
  }

}
